import styled, { css } from 'styled-components';
export const ModalContent = styled.div `
    ${props => {
    const backgroundColor = props.type && props.type === 'fullscreen' ? props.theme.background : props.theme.invertedText;
    return css `
            background: ${backgroundColor};
        `;
}}
`;
